// src/context/AuthContext.js
import React, { createContext, useState, useEffect } from "react";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
   const [loading, setLoading] = useState(true);
   
  const USER_LEVEL = {ADMIN: 2, SUB_ADMIN: 3, VENUE_MANAGER: process.env.REACT_APP_VENUE_MANAGER_USER_LEVEL};
  useEffect(() => {
    const fetchLoginDetails = () => {
      setLoading(true);
      const loginDetails = JSON.parse(localStorage.getItem("login_Details"));
    
      if (loginDetails?.authorisation?.token) {
        setUser({
          role: `${loginDetails?.type}`, // Example role, fetch this dynamically
          user_level: `${loginDetails?.user?.user_level}`,
        });
      }  else {
        setUser(null);
      }
      setLoading(false);
    };

    fetchLoginDetails(); // Initial fetch

    // Listen for custom login event
    window.addEventListener("login", fetchLoginDetails);

    // Cleanup listener on unmount
    return () => {
      window.removeEventListener("login", fetchLoginDetails);
    };
  }, []);

  return (
    <AuthContext.Provider value={{ user, setUser, USER_LEVEL ,loading}}>
      {children}
    </AuthContext.Provider>
  );
};
